import React, { memo, useState, useEffect, useCallback, useMemo } from "react";
import Button from "../../../shared/components/Button";
import { useDispatch } from 'react-redux';
import { setStoresFilters } from '../../../store/actions/filters';
import CreateByBash from "../CreateByBatch";
import ListDevicesToUpload from "./subComponents/ListDevicesToUpload";
import WarehouseAfterBatchModal from "../CreateByBatch/WarehouseAfterBatchModal";
import { useTranslation } from "react-i18next";
import styles from './createDevices.module.scss';

const CreateDevices = ({
    className,
    devices: {
        submitFetching,
        submitSuccess,
        submitValidateBatchFetching,
        submitValidateBatchSuccess,
        devicesBatchValidations
    },
    submitDevicesBatchRequest,
    submitDevicesValidateBatchRequest,
    setStateDevices,
    cleanValidatedDevices,
    patchDevicesRequest,
}) => {
    const { t } = useTranslation(["home", "devices"]);

    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [showWarehouseModal, setShowWarehouseModal] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);

    const showDevicesToLoad = useMemo(() =>
        Object.keys(devicesBatchValidations).length > 0
        && (devicesBatchValidations.available_to_insert.length > 0 || devicesBatchValidations.unavailable_to_insert.length > 0)
        , [devicesBatchValidations]);

    const dispatch = useDispatch();

    const handleOpenDialog = () => {
        dispatch(setStoresFilters({ type: ['device'], enabled: 'true' }));
        setIsOpenDialog(true);
    };


    const handleContinueToWarehouse = (file) => {
        setPendingFile(file);
        setIsOpenDialog(false); 
        setShowWarehouseModal(true);
    };

    const handleWarehouseClose = () => {
        setShowWarehouseModal(false);
        setPendingFile(null);
        setIsOpenDialog(false); 
    };

    const handleCloseDialog = useCallback(() => {
        setIsOpenDialog(false);
    }, []);

    const setDevecisToload = () => {
        setStateDevices({ devicesBatchValidations: {} });
    }

    useEffect(() => {

        if (submitSuccess) {
            // handleCloseDialog();
        }

        return () => {
            cleanValidatedDevices();
        }

    }, [submitSuccess, handleCloseDialog, cleanValidatedDevices]);

    return (
        <div>
            <Button className={styles.buttonImportar} onClick={handleOpenDialog}>
              <span>+</span>Importar dispositivos
            </Button>
            {isOpenDialog && !showWarehouseModal && (
                <CreateByBash
                    title={t("devices:upload_devices")}
                    subTitle={t("devices:upload_with_excel_file")}
                    open={isOpenDialog}
                    onClose={handleCloseDialog}
                    submitAction={submitDevicesBatchRequest}
                    submitValidateBatchAction={submitDevicesValidateBatchRequest}
                    submitFetching={submitFetching}
                    submitValidateBatchFetching={submitValidateBatchFetching}
                    submitValidateBatchSuccess={submitValidateBatchSuccess}
                    showItemToLoad={showDevicesToLoad}
                    onChangeFile={setDevecisToload}
                    onCancelAfterValidate={setDevecisToload}
                    onSubmitWithWarehouse={(payload, options) => {
                        

                        if (!payload.data?.substatus?.referenceId) {
                            if (options && options._warehouse && options._warehouse._id) {
                                payload = {
                                    ...payload,
                                    data: {
                                        ...payload.data,
                                        substatus: {
                                            ...payload.data.substatus,
                                            referenceId: options._warehouse._id
                                        }
                                    }
                                };
                            }
                        }
                    
                        // return patchDevicesRequest(payload);
                    }}
                    itemsToLoadAfterValidating={
                        <ListDevicesToUpload
                            itemsAvailableToInsert={devicesBatchValidations.available_to_insert}
                            itemsUnavailableToInsert={devicesBatchValidations.unavailable_to_insert}
                        />
                    }
                    type="devices"
                    onContinue={handleContinueToWarehouse}
                />
            )}
            {showWarehouseModal && (
                <WarehouseAfterBatchModal
                    open={showWarehouseModal}
                    onClose={handleWarehouseClose}
                    onContinue={() => {
                        setShowWarehouseModal(false);
                        setPendingFile(null);
                        setIsOpenDialog(false);
                    }}
                />
            )}
        </div>
    );
};

export default memo(CreateDevices);
